import { isArray, isEmpty } from 'lodash'

export default class ExternalStoreMapper {
  constructor (store) {
    this.store = store
  }

  mapGetters () {
    this.#validateArguments(arguments)

    if (arguments.length === 1) return this.#mapGetters(arguments[0])
    if (arguments.length === 2) return this.#mapGettersWithNamespace(arguments[0], arguments[1])
  }

  mapActions () {
    this.#validateArguments(arguments)

    if (arguments.length === 1) return this.#mapActions(arguments[0])
    if (arguments.length === 2) return this.#mapActionsWithNamespace(arguments[0], arguments[1])
  }

  mapMutations () {
    this.#validateArguments(arguments)

    if (arguments.length === 1) return this.#mapMutations(arguments[0])
    if (arguments.length === 2) return this.#mapMutationsWithNamespace(arguments[0], arguments[1])
  }

  #mapMutations (mutations = []) {
    return mutations.reduce((p, c) => {
      p[c] = (...args) => this.store.commit(c, ...args)
      return p
    }, {})
  }

  #mapMutationsWithNamespace (namespace, mutations = []) {
    const normalized = this.#normalizer(namespace)
    return mutations.reduce((p, c) => {
      p[c] = (...args) => this.store.commit(normalized(c), ...args)
      return p
    }, {})
  }

  #mapActions (actions = []) {
    return actions.reduce((p, c) => {
      p[c] = (...args) => this.store.dispatch(c, ...args)
      return p
    }, {})
  }

  #mapActionsWithNamespace (namespace, actions = []) {
    const normalized = this.#normalizer(namespace)
    return actions.reduce((p, c) => {
      p[c] = (...args) => this.store.dispatch(normalized(c), ...args)
      return p
    }, {})
  }

  #mapGetters (getters = []) {
    return getters.reduce((p, c) => {
      Object.defineProperty(p, c, { get: () => this.store.getters[c] })
      return p
    }, {})
  }

  #mapGettersWithNamespace (namespace, getters = []) {
    const normalized = this.#normalizer(namespace)
    return getters.reduce((p, c) => {
      Object.defineProperty(p, c, { get: () => this.store.getters[normalized(c)] })
      return p
    }, {})
  }

  #validateArguments (args) {
    if (args.length === 1) {
      if (!isArray(args[0])) throw new Error(`${args[0]} Must be an array`)
      return true
    }

    if (args.length === 2) {
      const namespace = args[0]
      const list = args[1]

      if (isEmpty(namespace)) throw new Error('Namespace must not be empty')
      if (!isArray(list)) throw new Error(`${args[1]} Must be an array`)
      return true
    }

    throw new Error('Invalid arguments')
  }

  #normalizer (namespace) { return namespaced => `${namespace}/${namespaced}` }
}
